<template>
  <a-modal :title="modal.title" v-model="modal.visible" @ok="handleOk" @cancel="handleCancel" :width="700">
    <div>
      <a-form class="flex-form" :form="modal.form" :colon="false" layout="inline">
        <a-form-item label="普通结算价" required>
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['ordinarySettlementPrice']"
            placeholder="请输入普通结算价"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="加急结算价" required>
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['urgentSettlementPrice']"
            placeholder="请输入加急结算价"
          ></a-input-number>
        </a-form-item>
        <a-form-item label="特急结算价" required>
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['superSettlementPrice']"
            placeholder="请输入特急结算价"
          ></a-input-number>
        </a-form-item>

        <a-form-item label="单程快递费" required>
          <a-input-number
            :min="0"
            :precision="2"
            v-decorator="['expressPrice']"
            placeholder="请输入单程快递费"
          ></a-input-number>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { toolMixin } from '@/utils/mixin'
export default {
  mixins: [toolMixin],
  data() {
    return {
      modal: {
        visible: false,
        form: this.$form.createForm(this),
        title: '',
        data: {},
      },
    }
  },
  methods: {
    async start(row) {
      this.resetModal$t()
      this.modal.visible = true
      this.modal.title = `${row.productName}`
      this.modal.data = {
        ...row,
      }
      this.safeSetFieldsValue$t(this.modal.form, { ...row })
      return new Promise((resolve, reject) => {
        this.$once('end', function (state, result) {
          if (state === 'ok') {
            resolve(result)
          }
          if (state === 'cancel') {
            reject(new Error('E_CANCEL'))
          }
          this.modal.visible = false
        })
      })
    },
    async handleOk() {
      this.modal.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/product-web-api/admin/product/settlementPriceNotarization', {
              data: {
                productId: this.modal.data.productId,
                ...params,
              },
            })
            this.$message.success('操作成功!')
            this.modal.visible = false
            this.$emit('end', 'ok')
          } catch (e) {}
        }
      })
    },
    handleCancel() {
      this.$emit('end', 'cancel')
    },
  },
}
</script>

<style></style>
